import { api } from '../axios'
import type { ApiResponse, School, Teacher } from '../../../types'

export interface DistrictWithStats {
  id: number;
  name: string;
  schools: number;
  teachers: number;
}

export const dashboardApi = {
  getDashboardStats: (params?: { transfersPeriod?: '30d' | '6m' | 'ytd' }) => {
    const qs = params?.transfersPeriod ? `?transfersPeriod=${encodeURIComponent(params.transfersPeriod)}` : ''
    return api.get<ApiResponse<{
      schools: number;
      teachers: number;
      districts: number;
      users: number;
      teacherStatus?: {
        active: number;
        suspended: number;
      };
      grievances?: {
        total: number;
      };
      medicalRecords?: {
        total: number;
      };
      transfers?: {
        total: number;
        recent: Array<{
          id: number;
          status: string;
          appliedAt: string | null;
          transferType: string | null;
          teacher: null | { id: number; teacher_ID: string; teacher_name: string };
          fromSchool: null | { school_id: string; school_name: string };
          toSchool: null | { school_id: string; school_name: string };
        }>;
      };
      transfersAtGlance?: {
        overall?: { pending: number; processing: number; approved: number; rejected: number; total: number };
        period?: {
          key: '30d' | '6m' | 'ytd';
          stats: { pending: number; processing: number; approved: number; rejected: number; total: number };
        };
      };
      transferWorkload?: {
        teacherInitiated: { pending: number; processing: number; approved: number; rejected: number; total: number };
        adminInitiated: { pending: number; processing: number; approved: number; rejected: number; total: number };
      };
      topDistrictsSnapshot?: Array<{
        district: string;
        transfers: number;
        grievances: number;
        medicalRecords: number;
      }>;
      schoolTypes: {
        primary: number;
        middle: number;
        high: number;
        higherSecondary: number;
        other: number;
      };
      userRoles: {
        superAdmin: number;
        admin: number;
        deo: number;
        sdeo: number;
        hoi: number;
        teacher: number;
        minister: number;
      };
      recentSchools: School[];
      recentTeachers: Teacher[];
      districtsWithStats?: DistrictWithStats[];
      staffIdCards?: {
        active: number;
        expiring: number;
        expired: number;
        recentlyIssued: number;
      };
      systemStats?: {
        staffIdCards?: {
          active: number;
          expiring: number;
          expired: number;
          recentlyIssued: number;
        };
      };
    }>>(`/dashboard/stats${qs}`)
  },

  getDashboardTargets: () =>
    api.get<ApiResponse<{
      schoolsTarget: number;
      teachersTarget: number;
    }>>('/dashboard/targets'),

  updateDashboardTargets: (payload: { schoolsTarget: number; teachersTarget: number }) =>
    api.put<ApiResponse<{
      schoolsTarget: number;
      teachersTarget: number;
    }>>('/dashboard/targets', payload),

  getRecentSchools: (limit = 5) =>
    api.get<ApiResponse<School[]>>(`/schools?page=1&limit=${limit}`),

  getRecentTeachers: (limit = 5) =>
    api.get<ApiResponse<Teacher[]>>(`/teachers?page=1&limit=${limit}`),

  getUsers: () =>
    api.get<ApiResponse<any[]>>('/users'),

  getSystemInfo: () =>
    api.get<ApiResponse<{
      version: string;
      lastUpdated: string;
      dbStatus: string;
      serverStatus: string;
      activeSessions: number;
    }>>('/audit/stats'),
}

